import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter, Linkedin, Youtube, Music } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-950 text-gray-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 lg:gap-12">
          <div className="col-span-2 md:col-span-4 lg:col-span-1 space-y-5">
            <Link to="/" className="inline-block">
              <img
                src="https://ighpjdpsntdcsdvqnipc.supabase.co/storage/v1/object/public/claritynews/Clarity%20News%20Logo.png"
                alt="Clarity News"
                className="h-10 w-auto brightness-200"
              />
            </Link>
            <p className="text-sm leading-relaxed text-gray-500">
              Stand on The Truth. Illuminating truth through journalism that matters.
            </p>
            <div className="flex items-center gap-3">
              {[
                { href: 'https://instagram.com/clarity.news', icon: Instagram, label: 'Instagram' },
                { href: 'https://twitter.com/BrettRaio', icon: Twitter, label: 'Twitter' },
                { href: 'https://linkedin.com/in/brettraio', icon: Linkedin, label: 'LinkedIn' },
                { href: 'https://youtube.com/BrettRaio', icon: Youtube, label: 'YouTube' },
                { href: 'https://tiktok.com/BrettRaio', icon: Music, label: 'TikTok' },
              ].map(({ href, icon: Icon, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-lg bg-gray-800/80 hover:bg-[#B6AC7D] flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label={label}
                >
                  <Icon className="h-4 w-4 text-gray-400 group-hover:text-white" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Explore</h3>
            <ul className="space-y-2.5">
              {[
                { to: '/', label: 'Home' },
                { to: '/latest', label: 'Latest' },
                { to: '/all-articles', label: 'All Articles' },
                { to: '/about', label: 'About' },
                { to: '/contact', label: 'Contact' },
                { to: '/subscribe', label: 'Subscribe' },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className="text-sm hover:text-[#B6AC7D] transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Categories</h3>
            <ul className="space-y-2.5">
              {['Politics', 'Technology', 'Business', 'Health', 'Science', 'Culture', 'World', 'Lifestyle'].map((cat) => (
                <li key={cat}>
                  <Link
                    to={`/category/${cat.toLowerCase()}`}
                    className="text-sm hover:text-[#B6AC7D] transition-colors"
                  >
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Brett Raio</h3>
            <ul className="space-y-2.5">
              {[
                { href: 'https://BrettRaio.com', label: 'BrettRaio.com' },
                { href: 'https://instagram.com/BrettRaio', label: 'Instagram' },
                { href: 'https://twitter.com/BrettRaio', label: 'Twitter' },
                { href: 'https://threads.com/BrettRaio', label: 'Threads' },
                { href: 'https://linkedin.com/in/brettraio', label: 'LinkedIn' },
                { href: 'https://youtube.com/BrettRaio', label: 'YouTube' },
              ].map(({ href, label }) => (
                <li key={href}>
                  <a href={href} target="_blank" rel="noopener noreferrer" className="text-sm hover:text-[#B6AC7D] transition-colors">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Contact</h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="mailto:news@KingdomClarity.io" className="hover:text-[#B6AC7D] transition-colors">
                  news@KingdomClarity.io
                </a>
              </li>
              <li>
                <a href="tel:207-712-9344" className="hover:text-[#B6AC7D] transition-colors">
                  207-712-9344
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-600">&copy; {new Date().getFullYear()} Clarity News. All rights reserved.</p>
          <div className="flex items-center gap-6 text-xs">
            <Link to="/privacy" className="text-gray-600 hover:text-gray-400 transition-colors">Privacy</Link>
            <Link to="/terms" className="text-gray-600 hover:text-gray-400 transition-colors">Terms</Link>
            <Link to="/sitemap" className="text-gray-600 hover:text-gray-400 transition-colors">Sitemap</Link>
          </div>
          <p className="text-xs text-gray-700">
            Built by{' '}
            <a href="https://VISIONStudios.io" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#B6AC7D] transition-colors">
              VISION Studios
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
